import { PRINTER_TYPES } from "@/modules/printManager/Utils";
import { requestInfo } from "@/providers/RoloProvider";

export default {
  data() {
    return {
      loader: false,
      isValid: false,
      // requestIns
      req: {
        receipt_settings: {
          printer_type: PRINTER_TYPES.NO_PRINT.value,
          printer_id: null,
          printer_name: "",
          printer_ip: null,
          device_id: null,
        },
        kot_settings: {
          printer_type: PRINTER_TYPES.NO_PRINT.value,
          printer_id: null,
          printer_name: "",
          printer_ip: null,
          device_id: null,
          chef_print: false,
          use_kot_config: false,
          same_as_receipt: false,
        },
      },
    };
  },
  methods: {
    //submit printer form
    submit() {
      const req = requestInfo();
      const storeId = localStorage.getItem("storeId");
      const nodeId = req.info.node_id;
      const url = `${this.$apiURL}store/${storeId}/node/${nodeId}/set_node_printer`;
      this.$http
        .post(url, this.req)
        .then((resp) => {
          this.$store.commit("showSnackbar", {
            message: resp.body.message,
          });

          // fetch updated settings.
          this.getPrinter();
        })
        .catch((failure) => {
          this.handleFailure(failure);
        });
    },

    // handle and show failure message
    handleFailure: function (failure) {
      let msg = failure.body.message || "Error";
      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error",
      });
    },

    // onFetchPrinter reform the form data based on server response
    onFetchPrinter(response) {
      this.req = response;
      this.loader = false;
    },

    // fetch configured printer settings
    getPrinter() {
      this.loader = true;
      let req = requestInfo();
      const storeId = localStorage.getItem("storeId");
      const url = `${this.$apiURL}store/${storeId}/node/${req.info.node_id}/get_printer_settings`;
      this.$http
        .get(url)
        .then((resp) => {
          this.onFetchPrinter(resp.body);
        })
        .catch((failure) => {
          this.loader = false;
          this.handleFailure(failure);
        });
    },
  },
  created() {
    this.getPrinter();
  }
};
